export default function Auth(state = {
  gates: []
}, action) {
  switch (action.type) {
    default:
      return state;
  }
}